var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.0013,
    height: 16.0013,
    viewBox: "0 0 15.0013 16.0013",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.49992 0C5.84271 0 4.49927 1.34344 4.49927 3.00066C4.49927 4.48754 5.58073 5.72183 6.99999 5.95985V7.5H4C3.17157 7.5 2.5 8.17157 2.5 9V10.0416C1.0811 10.2799 0 11.514 0 13.0007C0 14.6579 1.34344 16.0013 3.00066 16.0013C4.65787 16.0013 6.00131 14.6579 6.00131 13.0007C6.00131 11.5136 4.91954 10.2791 3.5 10.0414V9C3.5 8.72386 3.72386 8.5 4 8.5H11C11.2761 8.5 11.5 8.72386 11.5 9V10.0416C10.0811 10.2799 9 11.514 9 13.0007C9 14.6579 10.3434 16.0013 12.0007 16.0013C13.6579 16.0013 15.0013 14.6579 15.0013 13.0007C15.0013 11.5136 13.9195 10.2791 12.5 10.0414V9C12.5 8.17157 11.8284 7.5 11 7.5H7.99999V5.95983C9.41918 5.72176 10.5006 4.48749 10.5006 3.00066C10.5006 1.34344 9.15714 0 7.49992 0ZM5.49927 3.00066C5.49927 1.89572 6.39499 1 7.49992 1C8.60485 1 9.50058 1.89572 9.50058 3.00066C9.50058 4.10559 8.60485 5.00131 7.49992 5.00131C6.39499 5.00131 5.49927 4.10559 5.49927 3.00066ZM1 13.0007C1 11.8957 1.89572 11 3.00066 11C4.10559 11 5.00131 11.8957 5.00131 13.0007C5.00131 14.1056 4.10559 15.0013 3.00066 15.0013C1.89572 15.0013 1 14.1056 1 13.0007ZM12.0007 11C13.1056 11 14.0013 11.8957 14.0013 13.0007C14.0013 14.1056 13.1056 15.0013 12.0007 15.0013C10.8957 15.0013 10 14.1056 10 13.0007C10 11.8957 10.8957 11 12.0007 11Z",
    fill: "#065B70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavOrganization);
export default __webpack_public_path__ + "static/media/nav-organization.423e35edaf88bdc32e3be6d91571b26c.svg";
export { ForwardRef as ReactComponent };